import React from 'react';
import styled from 'styled-components';

// Base styled input
const BaseInput = styled.input`
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  &:focus {
    outline: none;
    border-color: #0066cc;
  }
`;

// Error message styling
const ErrorMessage = styled.span`
  color: #dc3545;
  font-size: 0.8rem;
  margin-top: 4px;
  display: block;
`;

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string;
  maxCharacters?: number;
}

export const InputNumber: React.FC<InputProps> = ({ 
  error, 
  onChange, 
  value = "",  // Garantir que o valor seja sempre uma string, caso contrário, será "não controlado"
  maxCharacters,
  ...props 
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    
    // Validação para permitir apenas números
    const numbersOnly = /^[0-9]*$/;

    // Só atualiza o valor se for válido ou estiver vazio
    if (numbersOnly.test(newValue)) {
      onChange?.(e);  // Chama a função onChange passada como props
    }
  };

  return (
    <div>
      <BaseInput
        value={value}  // Garantir que o valor seja controlado
        onChange={handleChange}
        maxLength={maxCharacters}
        {...props}  // Passa as demais props, como "placeholder", "name", etc.
      />
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </div>
  );
};
